<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>通行证统计</span>
        </div>

        <countStat ref="countStat" />

      </el-card>

      <el-row :gutter="12">
        <levelStat ref="levelStat" />
      </el-row>

      <el-card>
        <div slot="header" class="clearfix">
          <span>任务完成统计</span>
        </div>

        <el-row :gutter="12">
          <taskRate ref="taskCount" />
        </el-row>

        <!--        <el-row :gutter="12">-->
        <!--          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
        <!--            <taskRate ref="taskCount" />-->

        <!--          </el-col>-->
        <!--          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">-->
        <!--            <taskRate ref="taskRate" :title="'占比'" :k="'rate'" />-->
        <!--          </el-col>-->
        <!--        </el-row>-->
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getBuyGamePassStat, getBuyLevelGamePassStat, getGamePassTaskStat } from '@/api/user/user_info'
import countStat from '@/views/config/game-pass-stat/components/count-stat.vue'
import levelStat from '@/views/config/game-pass-stat/components/level-stat.vue'
import taskRate from '@/views/config/game-pass-stat/components/task-rate.vue'
import { getLastDates, scientificFormat } from '@/utils'
export default {
  name: 'GamePassStat',
  components: {
    countStat,
    levelStat,
    taskRate
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables()
    this.getLevelStat()
    this.getGameTaskStat()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
      this.getLevelStat()
      this.getGameTaskStat()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getBuyGamePassStat(this.queryParams).then(res => {
        this.$refs.countStat.refresh(res.data.data, res.data.dayData)
      })
    },
    getLevelStat() {
      getBuyLevelGamePassStat(this.queryParams).then(res => {
        this.$refs.levelStat.refresh(res.data)
      })
    },
    getGameTaskStat() {
      getGamePassTaskStat(this.queryParams).then(res => {
        this.$refs.taskCount.refresh(res.data.data, res.data.taskType)
        // this.$refs.taskRate.refresh(res.data.data, res.data.taskType)
      })
    }
  }
}
</script>

<style scoped>
</style>
